<template>
  <ui-modal
    ref="modal"
    :title="title"
    size="auto"
    @close="
      actionSetVisibleModalReservaBooking(false);
      cerrarModal();
      ActionSetZindexModal(false);
      actionSetGoTabSolicitudReserva(0)
    "
    id="nuevaReservaFormComponent"
    style="margin-top: 0px !important"
  >

    <!-- Información de la ruta -->
    <div>
      <fieldset-component
        texto="Información relevante a la ruta"
        bold
        class="mb-3"
        :error="validacionRelevanteALaRuta.error"
        :success="validacionRelevanteALaRuta.success"
      />

      <div class="px-4">
        <!-- Fila 1 -->
        <div class="d-flex">
          <!-- Año -->
          <ui-select
            class="w-50"
            has-search
            label="Año (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataAnios"
            v-model="anioModel"
          />

          <!-- Semana -->
          <ui-select
            class="w-50 ml-3"
            has-search
            label="Semana (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataSemanas"
            v-model="semanaModel"
          />

          <!-- Empresa -->
          <ui-select
            v-if="usuarioActual.rol == 'Super Administrador' || usuarioActual.rol == 'Administrador' || usuarioActual.rol == 'Ejecutivo' || usuarioActual.rol == 'Operador'"
            class="w-50 ml-3"
            has-search
            label="Empresas  (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listaClientesUsuarioActual"
            v-model="ClientesModel"
            @change="obtenerDataShippers(ClientesModel.id)"
          />

          <ui-textbox
            v-else
            class="w-50 ml-3"
            floating-label
            label="Empresa (*)"
            disabled
            v-model="clienteModel"
          />
          
        </div>

        <!-- Fila 2 -->
        <div class="d-flex mt-3">
          <ui-select
            class="w-50"
            has-search
            label="Puerto de embarque POL (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataPuertoDescarga"
            v-model="cargaModel"
            @change="informacionDeRuta()"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Lugar de origen  (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataPuertoDescarga"
            v-model="origenModel"
            @change="informacionDeRuta()"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Puerto de descarga - POD (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataPuertoDescarga"
            v-model="descargaModel"
            @change="informacionDeRuta()"
          />
        </div>

        <!-- Fila 3 -->
        <div class="d-flex mt-3">
          <ui-select
            class="w-50"
            has-search
            label="Lugar de destino final  (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataPuertoDescarga"
            v-model="destinoModel"
            @change="informacionDeRuta()"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Nave"
            v-model="naveModel"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Viaje"
            v-model="viajeModel"
          />
        </div>

        <!-- Fila 4 -->
        <div class="d-flex align-items-center justify-content-between mt-2">
          <!-- v-if="usuarioActual.id_country != 64" -->
          <ui-switch v-model="transporteTerrestreModel"
            >¿Transporte terrestre?</ui-switch
          >

          <Button
            :size="17"
            :width="170"
            :height="30"
            text="Seleccionar Nave y Viaje"
            color="#0174f3"
            colorText="#ffffff"
            icon="fas fa-ship"
            tooltip="Seleccionar Nave y Viaje"
            horizontal
            @click.native="actionSetVisibleModalSeleccionNave(true)"
          />

          <seleccion-nave-modal
            :year="anioModel"
            :week="semanaModel"
            :pod="descargaModel"
            :type="contenedorAsolicitarModel"
          />
        </div>
      </div>
    </div>

    <!-- Información de camionaje -->
    <div class="mt-4">
      <fieldset-component
        texto="Información de camionaje"
        bold
        class="mb-3"
        :error="validacionInformacionCamionaje.error"
        :success="validacionInformacionCamionaje.success"
      />

      <div>
        <!-- Fila -->
        <div class="d-flex px-4">
          <ui-textbox
            class="w-50"
            floating-label
            label="Tipo movimiento"
            v-model="tipoMovimientoModel"
            disabled
          />
          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Costo camionaje"
            v-model="costoCamionajeModel"
            disabled
          />
          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Tipo de Transporte"
            v-model="tipoTransporteModel"
            disabled
          />
        </div>

        <!-- Fila 2 -->
        <div class="d-flex px-4" v-if="transporteTerrestreModel">
          <ui-select
            class="w-50"
            has-search
            label="Lugar de carga"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataPuertoDescarga"
            v-model="lugarCargaModel"
          />

          <div class="d-flex flex-column w-50">
            <label class="content-datepicker">Fecha retiro unidad</label>

            <date-picker
              format="YYYY-MM-DD"
              type="date"
              v-model="fechaRetiroModel"
            ></date-picker>
          </div>

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Tipo chasis (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataTipoChasis"
            v-model="tipoChasisModel"
          />
        </div>

        <!-- Fila 3 -->
        <div class="d-flex px-4" v-if="transporteTerrestreModel">
          <ui-select
            class="w-50"
            has-search
            label="Packing"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listaPackingAux"
            v-model="packingModel"
            @change="seleccionarDireccion"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Dirección packing"
            v-model="direccionPackingModel"
            disabled
          />

          <ui-select
            v-if="tipoTransporteModel == 'MH Mercahnt Haulage'"
            class="w-50 ml-2"
            has-search
            label="Transportista"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            v-model="transportistaModel"
            :options="listaTransportista"
            :keys="{ value: 'id', label: 'name' }"
          />
        </div>
      </div>
    </div>

    <!-- Información de Servicio Integral -->
    <div>
      <fieldset-component
        texto="Información de Servicio Integral"
        bold
        class="mb-3 mt-4"
        :error="validacionInformacionServicioIntegral.error"
        :success="validacionInformacionServicioIntegral.success"
      />

      <div class="d-flex px-4">
        <ui-select
          class="w-50"
          has-search
          label="¿Servicio Integral? (*)"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :options="['Si', 'No']"
          v-model="servicioIntegralModel"
          @change="selectTipoServicioIntegral"
        />

        <ui-select
          v-if="mostrarTipoServicioIntegral"
          class="w-50 ml-3"
          has-search
          label="Tipo Servicio Integral (*)"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          :options="dataserviciosIntegrales"
          v-model="tipoServicioIntegralModel"
        />
      </div>
    </div>

    <!-- Información relevante a shipper -->
    <div>
      <fieldset-component
        texto="Información relevante a shipper"
        bold
        class="mb-3 mt-4"
        :error="validacionInformacionShipper.error"
        :success="validacionInformacionShipper.success"
      />

      <div class="px-4">
        <div class="d-flex">
          <ui-select
            class="w-50"
            has-search
            label="Shipper (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listaShippersAux"
            v-model="shipperModel"
            @change="seleccionarDireccionShipper();setSelectAndOptionsEmbarcador()"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Dirección shipper  (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            ref="selectDireccionesShippers"
            :keys="{ value: 'id', label: 'name' }"
            :options="listarDireccionesShippers"
            v-model="direccionShipperModel"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Consignatario"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            ref="selectListarConsignatarios"
            :keys="{ value: 'id', label: 'name' }"
            :options="listarConsignatarios"
            v-model="consignatarioModel"
          />
        </div>

        <div class="d-flex">
          <ui-select
            has-search
            class="w-50"
            label="Notificado"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listarNotificados"
            v-model="notificadoModel"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Embarcador (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="shippers"
            v-model="shipper"
          />
        </div>
      </div>
    </div>

    <!-- Información relevante a la carga -->
    <div>
      <fieldset-component
        texto="Información relevante a la carga"
        bold
        class="mb-3 mt-4"
        :error="validacionInformacionRelevanteCarga.error"
        :success="validacionInformacionRelevanteCarga.success"
      />

      <div class="px-4">
        <!-- Fila 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50"
            has-search
            label="Contenedor a solicitar (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataContenedores"
            v-model="contenedorAsolicitarModel"
            @change="isReeferValidate"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Producto a exportar (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listaProductosExportarAux"
            v-model="productoExportarModel"
            @change="
              obtenerRefigeracionProductoSeleccionado(productoExportarModel.id)
            "
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            type="number"
            label="Cantidad de contenedores a solicitar (*)"
            v-model="cantidadDeContenedoresAsolicitarModel"
          />
        </div>

        <!-- Fila 2 -->
        <div class="d-flex" v-if="isReefer">
          <ui-textbox
            class="w-50"
            label="Temperatura °C (*)"
            @blur="clearCharactersTemperature()"
            placeholder="4.5"
            help="Ejemplos: 0.2 , 4.5, 0.01"
            v-model="temperaturaModel"
          />
          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="% Ventilación (*)"
            v-model="ventilacionModel"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="Ventilación CBM (*)"
            v-model="ventilacionCMBModel"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Con Cold Treatment (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="[
              { id: 1, name: 'Si' },
              { id: 0, name: 'No' },
            ]"
            v-model="coldTreatmentModel"
          />
        </div>

        <!-- Fila 3 -->
        <div class="d-flex" v-if="isAtmosphera">
          <ui-select
            class="w-50"
            has-search
            label="Atmósfera controlada (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listaAtmosferas"
            v-model="atmosferaControladaModel"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="% Oxígeno (O2) (*)"
            v-model="porcentajeOxigeno"
          />

          <ui-textbox
            class="w-50 ml-3"
            floating-label
            label="% CO2 (*)"
            v-model="porcentajeCO2"
          />

          <div class="w-50 ml-3"></div>
        </div>
      </div>
    </div>

    <!-- Información adicional-->
    <div>
      <fieldset-component
        texto="Información adicional"
        bold
        class="mb-3 mt-4"
        :error="validacionInformacionAdicional.error"
        :success="validacionInformacionAdicional.success"
      />

      <div class="px-4">
        <!-- Fila 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50"
            has-search
            label="Forma de pago (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataMetodosPago"
            v-model="formaDePagoModel"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Uso de genset de la naviera"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="[
              { id: 1, name: 'Si' },
              { id: 0, name: 'No' },
            ]"
            v-model="usoGensetNavieraModel"
          />
        </div>

        <!-- Fila 2 -->
        <div class="d-flex">
          <ui-textbox
            class="w-50"
            floating-label
            label="Emisión de BL (*)"
            v-model="emisionBlModel"
          />

          <ui-select
            class="w-50 ml-3"
            has-search
            label="Contrato (*)"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="listarContratosOptions"
            v-model="contratoModel"
          />
        </div>

        <!-- Fila 2.1 -->
        <div class="d-flex" v-if="mostrarNumeroContratoManual">
          <ui-textbox
            class="w-100"
            floating-label
            label="Nro. Contrato (*)"
            v-model="contrato_booking"
            title="Nro. de Contrato ingresado se utilizará en la generación de los respectivos bs/l. UCC no será responsable por el mal ingreso de ésta información."
          />
        </div>

        <!-- Fila 3 -->
        <div class="d-flex">
          <ui-textbox
            class="w-100"
            floating-label
            label="Comentarios"
            multiLine
            style="min-height: 115px !important"
            :rows="5"
            v-model="comentariosModel"
          />
        </div>
      </div>
    </div>

    <!-- Botones -->
    <div class="d-flex justify-content-between pb-5">
      <Button
        text="Cancelar"
        class="w-50"
        style="margin-bottom: 0px !important"
        color="#c12020"
        colorText="#fff"
        icon="fas fa-times"
        title="Cancelar"
        horizontal
        @click.native="cerrarTodo(), actionSetGoTabSolicitudReserva(0)"
      />

      <Button
        v-if="estadoEnviadoDatos"
        text="Crear Reserva"
        style="margin-bottom: 0px !important"
        color="#21831b"
        colorText="#fff"
        icon="far fa-paper-plane"
        title="Crear Reserva"
        horizontal
        inactive
      />

      <Button
        v-else
        @click.native="validarBooking"
        text="Crear Reserva"
        style="margin-bottom: 0px !important"
        color="#21831b"
        colorText="#fff"
        icon="far fa-paper-plane"
        title="Crear Reserva"
        horizontal
      />
    </div>
  </ui-modal>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

// Keen UI
import UiModal from "keen-ui/lib/UiModal";
import UiTextbox from "keen-ui/lib/UiTextbox";
import UiSwitch from "keen-ui/lib/UiSwitch";
import UiSelect from "keen-ui/lib/UiSelect";

// Componentes
import Button from "../Button";

// Select Vue
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";

// Constantes
import {
  saveReserva,
  obtenerContrato,
  obtenerShippers,
  obtenerDireccionesPorShipper,
  obtenerRefigeracionProducto,
  obtenerProductosPorCliente,
  obtenerPackingsPorCliente,
  obtenerTransportistaPorCliente,
  getBookingsDeclarados,
  obtenerConsignatariosYNotificados,
  getSelectAndOptionsEmbarcador,
  getVerMisBookingsPorAceptar, getBookingsDeclaradosFiltrados
} from "../../../constants/lineas";

import FieldsetComponent from "../FieldsetComponent";
import SeleccionNaveModal from "../../modals/lineas/booking/SeleccionNaveModal";
import { getContadorBooking } from '../../../constants/dashboard';

export default {
  data() {
    return {
      // Variables auxiliares (Flags)
      EstadocargaModelLugarOrigenModel: false,
      EstadodescargaModelLugardestinoModel: false,
      tipoMovimientoModelAux_1: "",
      tipoMovimientoModelAux_2: "",
      camionajeData: {},
      isReefer: false,
      isAtmosphera: false,

      dataTipoChasis: [
        { id: 1, name: "Normal" },
        { id: 2, name: "3 Ejes" },
      ],

      // Información relevante a la ruta
      anioModel: "",
      semanaModel: {},
      clienteModel: "",
      ClientesModel: "",
      cargaModel: "",
      origenModel: "",
      descargaModel: {},
      destinoModel: "",
      naveModel: "",
      viajeModel: "",
      transporteTerrestreModel: false,
      transportistaModel: "",
      from_date: "",
      to_date: "",

      // Información de camionaje
      tipoMovimientoModel: "",
      costoCamionajeModel: "",
      tipoTransporteModel: "",

      lugarCargaModel: {},
      fechaRetiroModel: "",
      tipoChasisModel: "",
      packingModel: "",
      direccionPackingModel: "",

      // Información de Servicio Integral
      servicioIntegralModel: "",
      tipoServicioIntegralModel: "",
      mostrarTipoServicioIntegral: false,

      // Información relevante a shipper
      shipperModel: "",
      direccionShipperModel: "",
      consignatarioModel: "",
      notificadoModel: "",
      listarDireccionesShippers: [],

      // Información relevante a la carga
      contenedorAsolicitarModel: {},
      productoExportarModel: {},
      cantidadDeContenedoresAsolicitarModel: "",

      temperaturaModel: "",
      ventilacionModel: "",
      ventilacionCMBModel: "",
      coldTreatmentModel: "",

      // Información adicional
      formaDePagoModel: "",
      usoGensetNavieraModel: "",
      emisionBlModel: "",
      contratoModel: "",
      mostrarNumeroContratoManual: false,
      contrato_booking: "",
      comentariosModel: "",

      listarConsignatarios: [],
      listarNotificados: [],
      atmosferaControladaModel: [],
      porcentajeOxigeno: "",
      porcentajeCO2: "",
      naviera: "",
      clienteModelID: "",
      listarContratosOptions: [{id: 0, name: "Otro"}],

      listaProductosExportarAux: [],
      listaTransportista: [],
      itineraryIdModel: "",

      planned: 0,
      // Validaciones
      validacionRelevanteALaRuta: {
        error: false,
        success: false,
      },

      validacionInformacionCamionaje: {
        error: false,
        success: false,
      },

      validacionInformacionServicioIntegral: {
        error: false,
        success: false,
      },

      validacionInformacionShipper: {
        error: false,
        success: false,
      },

      validacionInformacionRelevanteCarga: {
        error: false,
        success: false,
      },

      validacionInformacionAdicional: {
        error: false,
        success: false,
      },
      listaShippersAux: [],

      estadoEnviadoDatos: false,
      shipper: "",
      user: {} ,
      showMessageTariff: true
    };
  },

  computed: {
    ...mapState("lineas", [
      "visibleModalReservaBooking",
      "formularioSolicitudNoPlanificada",
      "dataAnios",
      "dataSemanas",
      "dataContenedores",
      "dataPuertoDescarga",
      "dataMetodosPago",
      "dataserviciosIntegrales",
      "listaProductosExportar",
      "listaShippers",
      "listaPacking",
      "listaDireccionesShipper",
      "listaConsignatarios",
      "listaNotificados",
      "listaAtmosferas",
      "dataNaveSeleccionada",
      "shippers",
      "dataFormAgregarReservaFromItinerary",
      "isBookingPlanned",
      "flagFiltersBookings",
      "currentFiltersBookings"
    ]),

    ...mapState([
      "listaClientesUsuarioActual",
      "usuarioActual",
      'isAdmin',
      "url_actual",
      "zIndexModal",
    ]),
  },

  components: {
    UiModal,
    UiTextbox,
    UiSwitch,
    UiSelect,
    FieldsetComponent,
    Button,
    DatePicker,
    SeleccionNaveModal,
  },

  props: {
    title: { type: String, default : "Solicitud de reserva" }
  },
  methods: {

    ...mapActions(["ActionSetLoadingTable", "ActionSetZindexModal"]),

    ...mapActions("lineas", [
      "actionSetVisibleModalReservaBooking",
      "actionSetVisibleModalSeleccionNave",
      "actionSetVisibleModalReservaBookingAux",
      "actionSetDatatableBookingsPorConfirmar",
      "actionSetDataDatatableBookingsDeclarados",
      "ActionSetContadorMenuBookings",
      "actionSetDatatableVerMisBookingsPorAceptar",
      "actionSetDataListaSemana",
      "actionSetDataListaSI",
      "actionSetDataListaPOD",
      "actionSetDataListaAnio",
      "actionSetDataListaComercial",
      "actionSetDataListaCliente",
      "actionSetGoTabSolicitudReserva",
      "actionSetIsBookingPlanned"
    ]),

    openModal(ref) {
      
      this.$refs[ref].open();

      setTimeout(() => {
        this.ActionSetZindexModal(true);
      }, 500);

    },

    validComments(){
      const reg = /ñ|Ñ|á|Á|é|É|í|Í|ó|Ó|ú|Ú/g ;

      return reg.test( this.comentariosModel );
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },

    cerrarModal() {
      this.ActionSetZindexModal(false);
    },
    clearCharactersTemperature(){

      let value = this.temperaturaModel + "" ;
      
      const reg = /[a-z]|[A-Z]/g ;

      value = value.trim() ;
      value = value.replaceAll( reg , "") ;
      value = value.replaceAll(',' , '.') ;

      const lastCharNoPermitidos = ['+','-',',','.'] ;
      const firstCharNoPermitidos = ['+',',','.'] ;

      let firstchar = value.charAt(0) ;
      let lastchar = value.charAt(value.length - 1) ;

      if( firstCharNoPermitidos.includes( firstchar ) ) value = value.slice(1) ;

      if( lastCharNoPermitidos.includes( lastchar ) ) value = value.slice(0,-1) ;
      
      this.temperaturaModel = value ;
    },
    validarTab(tab_index) {
      // Validación tab 1
      if (tab_index == 0) {
        // Limpiar variable

        return new Promise((resolve, reject) => {
          if (this.tipoPlanificacion != "") {
            this.tabActual = tab_index;
            this.textErrorAux = "";
            resolve(true);
          } else {
            this.textErrorAux = "Debe seleccionar un tipo de reserva";
            reject(true);
          }
        });

        //  Validación tab 2
      } else if (tab_index == 1) {
        // Limpiar variable
        this.textErrorAux = "";

        return new Promise((resolve, reject) => {
          if (Object.keys(this.filaSeleccionadaAux.data).length > 0) {
            this.textErrorAux = "";
            resolve(true);
          } else {
            this.textErrorAux = "Debe seleccionar una solicitud";
            reject(true);
          }
        });
      }
    },

    async actualizarCount(){
      const contadores = await getContadorBooking();
      this.ActionSetContadorMenuBookings(contadores[0]);
    },

    async enviarFormulario() {
      this.estadoEnviadoDatos = true;

      let data = {
        year: this.anioModel.id,
        week: this.semanaModel.id,
        containers_requested: this.cantidadDeContenedoresAsolicitarModel,
        container_id: this.contenedorAsolicitarModel.id,
        port_discharge_id: this.descargaModel.id,
        port_load_id: this.cargaModel.id,
        port_origin_id: this.origenModel.id,
        port_destination_id: this.destinoModel.id,
        id_client_product: this.productoExportarModel.id,
        emition_bl: this.emisionBlModel,
        stacking_day: null,

        // Contract
        contract: null,
        contrato_booking: this.contrato_booking,
        comment: this.comentariosModel,
        tariff_contract_id : this.contratoModel.id == 0 ? '' : this.contratoModel.id,

        has_si: this.servicioIntegralModel == 'Si' ? 1 : 0 ,
        si_type_id: this.tipoServicioIntegralModel.id,
        vessel: this.naveModel,
        voyage: this.viajeModel,
        shipper_address_id: this.direccionShipperModel.id,
        shipper_consignee_id: this.consignatarioModel.id,
        shipper_notify_id: this.notificadoModel.id,
        payment_method: this.formaDePagoModel.id ,
        id_client: this.clienteModelID,

        //
        // haulage_movement_type: this.tipoTransporteModel,
        haulage_movement_type: this.tipoMovimientoModel,
        haulage_cost: this.costoCamionajeModel,
        lugarCargaModel: this.lugarCargaModel.id,
        fechaRetiroModel: this.fechaRetiroModel,
        tipoChasisModel: this.tipoChasisModel.name,
        packingModel: this.packingModel.id,
        direccionPackingModel: this.direccionPackingModel,
        transportistaModel: this.transportistaModel.id,
        itinerary_id: this.itineraryIdModel,

        // datos nuevos de ventilacion
        container_temperature: this.temperaturaModel,
        container_cbm_ventilation: this.ventilacionCMBModel,
        container_percent_ventilation: this.ventilacionModel,
        container_atmosphere_id: this.atmosferaControladaModel.id,
        container_percent_co2: this.porcentajeCO2,
        container_percent_o2: this.porcentajeOxigeno,
        container_cold_treatment: this.coldTreatmentModel.id,
        planned: this.isBookingPlanned,
        shipper_id: this.shipper.id
      };

      this.$vToastify.loader("Creando Reserva...");

      // Enviar información de reserva a constante
      let sql = await saveReserva(data);

      // Cierre de modal
      this.actionSetVisibleModalReservaBooking(false);
      this.actionSetVisibleModalReservaBookingAux(false);
      this.closeModal("modal");

      if (!sql.error) {

        this.ActionSetLoadingTable(true);

        if (this.flagFiltersBookings) {

          let data = await getBookingsDeclaradosFiltrados(this.currentFiltersBookings);

          this.data = data;

          this.actionSetDataDatatableBookingsDeclarados(data);

        } else {

          let data  = await getBookingsDeclarados();

          this.data = data.data_table;

          this.actionSetDataDatatableBookingsDeclarados(data.data_table);

          // Filtros
          this.actionSetDataListaSemana(data.filtroSemanas);
          this.actionSetDataListaPOD(data.filtroPod);
          this.actionSetDataListaSI(data.filtroSI);
          this.actionSetDataListaAnio(data.filtroAnio);
          this.actionSetDataListaComercial(data.filtroComercial);
          this.actionSetDataListaCliente(data.filtroClientes);
        }

        this.$vToastify.stopLoader();

        this.$vToastify.success("Reserva realizada con éxito", "Éxito");

        await this.actualizarCount();

        this.cantidadDeContenedoresAsolicitarModel = "";
        this.contenedorAsolicitarModel = "";
        this.descargaModel = "";
        this.cargaModel = "";
        this.origenModel = "";
        this.destinoModel = "";
        this.productoExportarModel = "";
        this.emisionBlModel = "";
        this.contratoModel = "";
        this.contrato_booking = "";
        this.comentariosModel = "";
        this.servicioIntegralModel = "";
        this.tipoServicioIntegralModel = "";
        this.naveModel = "";
        this.viajeModel = "";
        this.direccionShipperModel = "";
        this.consignatarioModel = "";
        this.notificadoModel = "";
        this.formaDePagoModel = "";
        this.temperaturaModel = "";
        this.ventilacionModel = "";
        this.ventilacionCMBModel = "";
        this.coldTreatmentModel = [];

        this.validacionRelevanteALaRuta.error = false;
        this.validacionRelevanteALaRuta.success = false;

        this.validacionInformacionCamionaje.error = false;
        this.validacionInformacionCamionaje.success = false;

        this.validacionInformacionServicioIntegral.error = false;
        this.validacionInformacionServicioIntegral.success = false;

        this.validacionInformacionShipper.error = false;
        this.validacionInformacionShipper.success = false;

        this.validacionInformacionRelevanteCarga.error = false;
        this.validacionInformacionRelevanteCarga.success = false;

        this.validacionInformacionAdicional.error = false;
        this.validacionInformacionAdicional.success = false;

        const user = JSON.parse( localStorage.getItem('user') ) ;


        this.actionSetIsBookingPlanned(0);

        // Perfil Administrador
        if ( this.url_actual !== "/lineas/booking/bookings_declarados" && this.isAdmin ) {

          await this.$router.push({ path: "/lineas/booking/bookings_declarados" });

        }

        // Perfil cliente u otro que no sea administrador
        if ( this.url_actual !== "/lineas/booking/ver_bookings_por_aceptar" && user.id_role !== 1 && user.id_role !== 9999 && user.id_role !== 2 && user.id_role !== 5 ) {

          await this.$router.push({ path: "/lineas/booking/ver_bookings_por_aceptar"});

        } else {

          if( user.id_role !== 1 && user.id_role !== 9999 && user.id_role !== 2 && user.id_role !== 5 ){

            let dataPorAceptar = await getVerMisBookingsPorAceptar();

            this.actionSetDatatableVerMisBookingsPorAceptar( dataPorAceptar.data_table );

          }

        }

        this.estadoEnviadoDatos = false;

        this.ActionSetLoadingTable(false);

      } else {

        this.$vToastify.error(
          "No fue posible realizar la reserva",
          "Lo sentimos"
        );

        this.$vToastify.stopLoader();

        this.estadoEnviadoDatos = false;

      }
    },

    volverModalAnterior() {
      this.closeModal("modal");
      this.actionSetVisibleModalReservaBooking(false);
    },

    async setSelectAndOptionsEmbarcador(){

      if( this.shipperModel.id !== undefined ){

        const { data } = await getSelectAndOptionsEmbarcador( this.shipperModel.id ) ;
        
        if( data.options !== null ) this.shipper = data.options;

      }
    },

    informacionDeRuta() {
      if (
        !this.cargaModel ||
        !this.descargaModel ||
        !this.origenModel ||
        !this.destinoModel
      ) {
        return;
      }

      // cost y type sólo varian cuando el movementType = CY/CY, por lo cual se dejan
      // setteados con opciones por defectos para los casos restantes.
      this.costoCamionajeModel = "Naviera";
      this.tipoTransporteModel = "CH Carrier Haulage";

      // CY/CY
      if (
        this.origenModel.name == this.cargaModel.name &&
        this.descargaModel.name == this.destinoModel.name
      ) {
        // Información guardada en modelos
        this.tipoMovimientoModel = "CY/CY";
        this.tipoTransporteModel = "MH Mercahnt Haulage";
        this.costoCamionajeModel = "Cliente";

        // Información guardada en formulario
        this.tipoMovimientoModel = "CY/CY";
        this.costoCamionajeModel = "Cliente";
        this.tipoTransporteModel = "MH Mercahnt Haulage";

        //
      } else if (
        // Door to Port
        this.origenModel.name != this.cargaModel.name &&
        this.descargaModel.name == this.destinoModel.name
      ) {
        // Información guardada en modelos
        this.tipoMovimientoModel = "Door to Port";

        // Información guardada en formulario
        this.tipoMovimientoModel = "Door to Port";

        //
      } else if (
        // Port To Door
        this.origenModel.name == this.cargaModel.name &&
        this.descargaModel.name != this.destinoModel.name
      ) {
        // Información guardada en modelos
        this.tipoMovimientoModel = "Port To Door";

        // Información guardada en formulario
        this.tipoMovimientoModel = "Port To Door";

        //
      } else if (
        // Door To Door
        this.origenModel.name != this.cargaModel.name &&
        this.descargaModel.name != this.destinoModel.name
      ) {
        // Información guardada en modelos
        this.tipoMovimientoModel = "Door To Door";

        // Información guardada en formulario
        this.tipoMovimientoModel = "Door To Door";
      }
    },

    selectTipoServicioIntegral(data) {
      this.mostrarTipoServicioIntegral = data == "Si" ? true : false;
    },

    isReeferValidate(data) {
      this.isAtmosphera = data.with_ac;
      this.isReefer = data.with_frozen;

      if (data.with_frozen) {
        // this.booking.container_atmosphere_id.value = {};
        this.porcentajeOxigeno = "";
        this.porcentajeCO2 = "";
      } else {
        this.temperaturaModel = "";
        this.ventilacionModel = "";
        this.ventilacionCMBModel = "";
        this.atmosferaControladaModel = "";
        this.porcentajeOxigeno = "";
        this.porcentajeCO2 = "";
      }
    },

    seleccionarDireccion(direccion) {
      this.direccionShipperModel = "";

      Object.keys(direccion).length > 0
        ? (this.direccionPackingModel = direccion.address)
        : "";
    },

    async seleccionarDireccionShipper() {
      const { id_role } = JSON.parse(localStorage.getItem('user'));

      let id_shipper = this.shipperModel.id;
      // Limpieza de select
      /*
      setTimeout(() => {
        this.$refs.selectDireccionesShippers.reset();
        this.$refs.selectListarConsignatarios.reset();
        this.$refs.selectListarNotificados.reset();
      }, 700);
*/
      if ((id_role === 1 || id_role === 3 || id_role === 5 || id_role === 2 ) && (this.shipperModel.id !== undefined)) {
        let sql = await obtenerDireccionesPorShipper(id_shipper);
        this.listarDireccionesShippers = sql;
        this.direccionShipperModel = sql[0];

        this.obtenerConsignatariosYNotificadosData();
      } else {
        // Obtener lista de direcciones de acuerdo al Shipping seleccionado
        this.listaDireccionesShipper.map((item) => {
          if (item.id == id_shipper) {
            this.listarDireccionesShippers = item.data;
          }
        });

        // Obtener lista de consignatarios de acuerdo al Shipping seleccionado
        this.listaConsignatarios.map((item) => {
          if (item.id == id_shipper) {
            this.listarConsignatarios = item.data;
          }
        });

        // Obtener lista de notificados de acuerdo al Shipping seleccionado
        this.listaNotificados.map((item) => {
          if (item.id == id_shipper) {
            this.listarNotificados = item.data;
          }
        });
      }
    },

    // Validaciones
    validarInformacionRelevanteARuta() {
      if (
        Object.keys(this.anioModel).length > 0 &&
        Object.keys(this.semanaModel).length > 0 &&
        Object.keys(this.cargaModel).length > 0 &&
        Object.keys(this.origenModel).length > 0 &&
        Object.keys(this.descargaModel).length > 0 &&
        Object.keys(this.destinoModel).length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    validarInformacionCamionaje() {
      if (
        this.transporteTerrestreModel &&
        this.tipoMovimientoModel.length > 0 &&
        this.costoCamionajeModel.length > 0 &&
        this.tipoTransporteModel.length > 0
      ) {
        if (Object.keys(this.tipoChasisModel).length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        if (
          this.tipoMovimientoModel.length > 0 &&
          this.costoCamionajeModel.length > 0 &&
          this.tipoTransporteModel.length > 0
        ) {
          return true;
        } else {
          return false;
        }
      }
    },

    validarInformacionServicioIntegral() {
      if (this.servicioIntegralModel == "Si") {
        if (Object.keys(this.tipoServicioIntegralModel).length > 0) {
          return true;
        } else {
          return false;
        }
      } else if (this.servicioIntegralModel == "No") {
        return true;
      } else {
        return false;
      }
    },

    validarInformacionShipper() {
      if (
        Object.keys(this.shipperModel).length > 0 &&
        Object.keys(this.direccionShipperModel).length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    validarInformacionRelevanteCarga() {

      if (
        Object.keys(this.contenedorAsolicitarModel).length > 0 &&
        Object.keys(this.productoExportarModel).length > 0 &&
        // this.cantidadDeContenedoresAsolicitarModel != 0    &&
        this.cantidadDeContenedoresAsolicitarModel > 0    &&
        this.cantidadDeContenedoresAsolicitarModel != ""
      ) {
        // Si es de tipo Reefer aplican estas validaciones
        if (this.isReefer) {
          if (
            String(this.temperaturaModel) != "" &&
            String(this.ventilacionModel) != "" &&
            String(this.ventilacionCMBModel) != ""
          ) {
            return true;
          } else {
            return false;
          }
        }

        // Si es de tipo Atmosfera aplican estas validaciones
        if (this.isAtmosphera) {
          if (
            Object.keys(this.atmosferaControladaModel).length &&
            this.porcentajeOxigeno != "" &&
            this.porcentajeCO2 != ""
          ) {
            return true;
          } else {
            return false;
          }
        }

        return true;
      } else {
        return false;
      }
    },

    validarInformacionAdicional() {
      if (
        Object.keys(this.formaDePagoModel).length > 0 &&
        Object.keys(this.emisionBlModel).length > 0 &&
        this.isContract
      ) {
        
        return true;

      } else if( Object.keys(this.formaDePagoModel).length > 0 &&
        Object.keys(this.emisionBlModel).length > 0 &&
        !this.isContract &&
        this.contrato_booking.length > 0) {

          // Si es de tipo Reefer aplican estas validaciones
        if (this.mostrarNumeroContratoManual) {
          if (this.contrato_booking != "") {
            return true;
          } else {
            return false;
          }
        }

       return true;
      
      } else {
        return false;
      }
    },
    // Validación general
    validarBooking() {
      // ...::: 1era sección [Información relevante a la ruta] :::...
      let EstadovalidarInformacionRelevanteARuta =
        this.validarInformacionRelevanteARuta();

      if (EstadovalidarInformacionRelevanteARuta) {
        this.validacionRelevanteALaRuta.success = true;
        this.validacionRelevanteALaRuta.error = false;
      } else {
        this.validacionRelevanteALaRuta.success = false;
        this.validacionRelevanteALaRuta.error = true;
      }

      // ...::: 2da sección [Información de camionaje] :::...
      let EstadovalidarInformacionCamionaje =
        this.validarInformacionCamionaje();

      if (EstadovalidarInformacionCamionaje) {
        this.validacionInformacionCamionaje.success = true;
        this.validacionInformacionCamionaje.error = false;
      } else {
        this.validacionInformacionCamionaje.success = false;
        this.validacionInformacionCamionaje.error = true;
      }

      // ...::: 3era sección [Información de Servicio Integral] :::...
      let EstadoInformacionServicioIntegral =
        this.validarInformacionServicioIntegral();

      if (EstadoInformacionServicioIntegral) {
        this.validacionInformacionServicioIntegral.success = true;
        this.validacionInformacionServicioIntegral.error = false;
      } else {
        this.validacionInformacionServicioIntegral.success = false;
        this.validacionInformacionServicioIntegral.error = true;
      }

      // ...::: 4ta sección [Información relevante a shipper] :::...
      let EstadoInformacionShipper = this.validarInformacionShipper();

      if (EstadoInformacionShipper) {
        this.validacionInformacionShipper.success = true;
        this.validacionInformacionShipper.error = false;
      } else {
        this.validacionInformacionShipper.success = false;
        this.validacionInformacionShipper.error = true;
      }

      // ...::: 5ta sección [Información relevante a la carga] :::...
      let EstadoInformacionRelevanteCarga =
        this.validarInformacionRelevanteCarga();

      if (EstadoInformacionRelevanteCarga) {
        this.validacionInformacionRelevanteCarga.success = true;
        this.validacionInformacionRelevanteCarga.error = false;
      } else {
        this.validacionInformacionRelevanteCarga.success = false;
        this.validacionInformacionRelevanteCarga.error = true;
      }

      // ...::: 6ta sección [Información relevante a la carga] :::...
      let EstadoInformacionAdicional = this.validarInformacionAdicional();

      if (EstadoInformacionAdicional) {
        this.validacionInformacionAdicional.success = true;
        this.validacionInformacionAdicional.error = false;
      } else {
        this.validacionInformacionAdicional.success = false;
        this.validacionInformacionAdicional.error = true;
      }

      // Se valida que todas las secciones esten validadas
      if (
        EstadovalidarInformacionRelevanteARuta &&
        EstadovalidarInformacionCamionaje &&
        EstadoInformacionServicioIntegral &&
        EstadoInformacionShipper &&
        EstadoInformacionRelevanteCarga &&
        EstadoInformacionAdicional &&
        this.contratoModel.id !== undefined 
      ) {

        const valid = this.validComments();

        if( valid ) return this.$vToastify.warning("Favor, en el campo 'Comentarios' omitir acentos y caracter 'Ñ'." , "Error" );

        this.enviarFormulario();
      } else {
        this.$vToastify.error("Los campos con (*) son requerido." , "!Error¡" );
      }
    },

    async obtencionContrato() {

      if (
        Object.keys(this.cargaModel).length > 0 &&
        Object.keys(this.destinoModel).length > 0 &&
        Object.keys(this.productoExportarModel).length > 0 &&
        Object.keys(this.contenedorAsolicitarModel).length > 0 &&
        Object.keys(this.semanaModel).length > 0 &&
        this.from_date.length > 0 &&
        this.to_date.length > 0
      ) {
        let data = {
          pol: parseInt(this.cargaModel.id),
          pod: parseInt(this.destinoModel.id),
          naviera_id: parseInt(this.naviera.id),
          products_category_id: this.productoExportarModel.id_product_type,
          container_id: parseInt(this.contenedorAsolicitarModel.id),
          client_id: this.clienteModelID,
          atmosphere_id: this.atmosferaControladaModel.id,
          from_date: this.from_date,
        };

        let sql = await obtenerContrato(data);
        let dataSelectContratos = [];

        if (sql.length > 0) {

          sql.map(item => {
            dataSelectContratos.push({id: item.tariff_contract_id , name: item.contrato});
          });

          this.listarContratosOptions = [];
          this.listarContratosOptions = dataSelectContratos;
          this.listarContratosOptions.push({id: 0, name: "Otro"});
          this.isContract             = true;

        } else {

          this.listarContratosOptions = [];
          this.listarContratosOptions.push({id: 0, name: "Otro"});
          this.isContract             = false;

          if( this.showMessageTariff ){
            this.$vToastify.warning("Esta ruta no posee contrato, por favor contacte al administrador o ingrese su propio número de contrato.","!Precaución¡");
            this.showMessageTariff = false ;
          }

          setTimeout( () => this.showMessageTariff = true , 4000) ;

        }
      }
    },

    async obtenerDataShippers(id) {
      if (id != undefined) {
        // Variable auxiliar
        this.clienteModelID = id;

        // Obtener los packing de cada cliente seleccionado
        let sql_5 = await obtenerPackingsPorCliente(id);
        this.listaPackingAux = sql_5;
        this.packingModel = sql_5.length > 0 ? sql_5[0] : [];
        this.direccionPackingModel = sql_5.length > 0 ? sql_5[0].address : [];

        // Obtener los transportitas asociado a cada cliente seleccionado
        let sql_6 = await obtenerTransportistaPorCliente(id);
        this.listaTransportista = sql_6.length ? sql_6 : [];
        this.transportistaModel = sql_6.length ? sql_6[0] : [];

        // Obtención de data para select Shipper
        let sql = await obtenerShippers(id);
        this.listaShippersAux = sql;
        this.shipperModel = sql[0];

        // Obtención de data para dirección de shipper seleccionado
        let sql_2 = sql ? await obtenerDireccionesPorShipper(sql[0].id) : [];
        this.direccionShipperModel = sql_2 ? sql_2[0] : [];
        this.listarDireccionesShippers = sql_2;

        // Obtención de data para producto a exportar
        let sql_3 = await obtenerProductosPorCliente(id);

        this.productoExportarModel = sql_3.length ? sql_3[0] : [];
        this.listaProductosExportarAux = sql_3.length ? sql_3 : [];

        // Obtener la refigeración de los productos
        if( sql_3.length > 0 ){

          let sql_4 = sql_3 ? await obtenerRefigeracionProducto(sql_3[0].id) : [];
          
          if (sql_4.length > 0) {
            this.temperaturaModel = sql_4[0].temp;
            this.ventilacionModel = sql_4[0].vent;
            this.ventilacionCMBModel = sql_4[0].vent_cbm;
          }
        }
        
      }
    },

    async obtenerRefigeracionProductoSeleccionado(id_producto) {

      // let id_cliente = '';

      // if(this.isAdmin){
      //   id_cliente = this.ClientesModel.id;
      // }else{
      //   id_cliente = this.clienteModelID;
      // }

      let sql = await obtenerRefigeracionProducto(id_producto);

      if (sql.length > 0) {
        this.temperaturaModel = sql[0].temp;
        this.ventilacionModel = sql[0].vent;
        this.ventilacionCMBModel = sql[0].vent_cbm;
      }
    },

    cerrarTodo() {
      this.actionSetVisibleModalReservaBooking(false);
      this.closeModal("modal");
      this.cerrarModal();
    },

    async obtenerConsignatariosYNotificadosData() {
      const { data } = await obtenerConsignatariosYNotificados(
        this.shipperModel.id
      );

      this.listarConsignatarios =
        data.consignatarios === undefined ? [] : data.consignatarios;
      this.listarNotificados =
        data.notificados === undefined ? [] : data.notificados;

      // if (data.consignatarios !== undefined && data.consignatarios.length > 0) {
      //   this.consignatarioModel = data.consignatarios[0];
      // }

      // if (data.notificados !== undefined && data.notificados.length > 0) {
      //   this.notificadoModel = data.notificados[0];
      // }
    },
  },

  mounted(){
    this.user = JSON.parse( localStorage.getItem("user") );
  },

  watch: {
    visibleModalReservaBooking: function (_new) {
      if (_new) {
        this.openModal("modal");
      }
    },

    shipperModel: function (_new) {
      if (_new) {
        this.obtenerConsignatariosYNotificadosData();
        this.setSelectAndOptionsEmbarcador() ;
      }
    },

    formularioSolicitudNoPlanificada: async function (_new) {
      if (_new) {

        if (Object.keys(_new).length > 0) {
          this.anioModel = _new.anioModel;
          this.semanaModel = _new.semanaModel;
          this.destinoModel = _new.puertosModel;
          this.descargaModel = _new.puertosModel;
          this.contenedorAsolicitarModel = _new.contenedoresModel;

          this.clienteModel = this.usuarioActual.cliente;
          this.clienteModelID = this.usuarioActual.id_cliente;

          // Contenedores
          this.contenedorAsolicitar = _new.contenedoresModel;

          setTimeout(() => {
            this.isReeferValidate(_new.contenedoresModel);
          }, 500);

          this.cantidadDeContenedoresAsolicitarModel =
            _new.cantidadContenedoresModel;

          // Tab 1
          this.empresaModel = _new.empresa;

          if ( typeof _new.empresa == "object" ) {
            this.ClientesModel = _new.empresa;
            this.obtenerDataShippers(_new.empresa.id);
          }

          if( this.user.id_role == 3 ) await this.obtenerDataShippers( this.user.id_cliente );

        } 
      }
    },

    transporteTerrestreModel: function (_new) {
      if (_new) {
        this.transporteTerrestreModel = _new;
      }
    },

    dataNaveSeleccionada: function (_new) {
      this.naveModel = "";
      this.viajeModel = "";
      this.cargaModel = "";
      this.naviera = "";
      this.itineraryIdModel = "";


      if (_new) {
        
        this.comentariosModel = `Nave: ${_new.nave} Viaje: ${_new.viaje}`;

        this.naveModel = _new.nave;
        this.viajeModel = _new.viaje;
        this.cargaModel = _new.pol;
        this.naviera = _new.naviera;
        this.from_date = _new.from_date;
        this.to_date = _new.to_date;
        this.itineraryIdModel = _new.itinerary_id;

        this.obtencionContrato();
      }
    },

    // Modelos para obtener contrato
    cargaModel: function (_new) {
      if (_new) {
        // Habilitación de campos extras para sección (Información de camionaje)
        this.origenModel = _new;
        this.informacionDeRuta();
        this.obtencionContrato();
      }
    },

    descargaModel: function (_new) {
      if (_new) {
        // Habilitación de campos extras para sección (Información de camionaje)
        this.destinoModel = _new;
        this.informacionDeRuta();
      }
    },
    
    destinoModel: function(_new){

      if (_new) {
        this.obtencionContrato();
      }

    },

    productoExportarModel: function (_new) {
      if (_new) {
        this.obtencionContrato();
      }
    },

    contenedorAsolicitarModel: function (_new) {
      if (_new) {
        this.obtencionContrato();
      }
    },

    atmosferaControladaModel: function (_new) {
      if (_new) {
        this.obtencionContrato();
      }
    },

    // From Date
    from_date: function (_new) {
      if (_new) {
        this.obtencionContrato();
      }
    },

    // To Date
    to_date: function (_new) {
      if (_new) {
        this.obtencionContrato();
      }
    },

    semanaModel: function (_new) {
      if (_new) {
        this.obtencionContrato();
      }
    },

    contratoModel: function (_new) {

      if (_new.name == "Otro") {
        this.mostrarNumeroContratoManual = true;
      } else {
        this.mostrarNumeroContratoManual = false;
      }
    },

    listaShippers: async function (_new) {
      this.listaShippersAux = _new;
    },

    listaProductosExportar: function (_new) {
      _new && (this.listaProductosExportarAux = _new);
    },

    listaPacking: function (_new) {
      _new && (this.listaPackingAux = _new);
    },

    dataFormAgregarReservaFromItinerary: function(_new){

      if( _new ){
        this.semanaModel   = _new.semana ;
        this.anioModel     = _new.anio ;
        this.destinoModel  = _new.port_of_discharge ;
        this.descargaModel = _new.port_of_discharge ;
        this.clienteModel  = _new.client ;

        this.user.id_role == 3 && this.obtenerDataShippers( _new.clientId );
        
      }
    }
  },
};
</script>

<style>
#nuevaReservaFormComponent .ui-modal__container {
  width: 80% !important;
}
.wizard-footer-right {
  display: inline-block !important;
}

#nuevaReservaFormComponent .mx-input {
  padding-left: 2px !important;
  border-radius: 0px !important;
  border: none !important;
  border-bottom: 1px solid #dcdcdc !important;
  box-shadow: none !important;
}

#nuevaReservaFormComponent .mx-datepicker {
  margin-left: 10px;
  width: 99% !important;
}

#nuevaReservaFormComponent .content-datepicker {
  color: #757575 !important;
  margin-left: 15px !important;
  margin-top: -10px !important;
  width: 50% !important;
}

#nuevaReservaFormComponent .vt-paragraph {
  text-align: justify;
  font-size: 13px;
}

#nuevaReservaFormComponent .vt-content {
  padding-right: 10px;
}

#nuevaReservaFormComponent .ui-focus-container .ui-modal__container {
  margin-top: 0px !important;
}
</style>
